export default __webpack_public_path__ + "static/media/tp-loja-roupa.104507f0.webp";